import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import styles from '../../../styles';
import { ColumnBlock } from '../../layout/components';
import { PreloadImage } from '../../pages/components';

import * as navigationActions from '../../navigation/navigation.actions';

const ImageBlockWrapper = styled.div`
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? 1.875 : 3.75}rem;
  padding-right: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? 3.75 : 5.625}rem;
`;

const ImageBlock = styled(ColumnBlock)`
  text-align: center;
  margin-left: 0;
  overflow: visible;
  display: block;
  figure {
    width: 100%;
    padding-top: 100%;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    img {
      transform: scale(1);
      transform-origin: 50% 50%;
      transition-property: transform;
      transition-timing-function: ${styles.easing.inOutQuad};
      transition-duration: 0.25s;
    }

    ${props =>
      (props.narrow || props.breakpoint === 'phone') &&
      `
    `} img {
      width: 100%;
      height: auto;
    }
  }
`;

const StyledColumnBlock = styled(ColumnBlock)`
  margin-bottom: 1.0rem;
  padding-top: 2.125rem;
`;

class GreenSectionImageBlock extends PureComponent {
  state = {
    hover: false,
  };

  render() {
    const {
      breakpoint,
      image,
      fullWidth,
      narrow,
    } = this.props;
    const numContainerColumns = 1;

    return (
      <StyledColumnBlock 
        parentColumns={fullWidth ? numContainerColumns : null}
        columns={numContainerColumns}
        flex
      >
          <ImageBlock
            narrow={narrow}
            parentColumns={numContainerColumns}
            breakpoint={breakpoint}
          >
            <ImageBlockWrapper breakpoint={breakpoint}>
              <figure>
                <PreloadImage src={image} />
                {/*<HoverBlock />*/}
              </figure>
            </ImageBlockWrapper>
          </ImageBlock>

      </StyledColumnBlock>
    );
  }
}

GreenSectionImageBlock.propTypes = {
  breakpoint: PropTypes.string,
  image: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  narrow: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, navigationActions)(GreenSectionImageBlock);



// WEBPACK FOOTER //
// ./src/modules/pages/components/GreenSectionImageBlock.js